module.exports = __webpack_public_path__ + "static/UNL-099b81fb0ac9042cab91ac1e63560e81.woff";